import { S3Client } from "@aws-sdk/client-s3";
import { fromTemporaryCredentials } from "@aws-sdk/credential-providers";

export const createS3Client = ({
  roleArn,
  accessKeyId,
  secretAccessKey,
  sessionToken,
  bucket,
}) => {
  const credentials = fromTemporaryCredentials({
    params: { RoleArn: roleArn },
    masterCredentials: {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    },
    clientConfig: { region: "us-east-1" },
  });

  return { client: new S3Client({ region: "us-east-1", credentials }), bucket };
};

export default createS3Client;
